import LensIcon from '@mui/icons-material/Lens';
import React, { useEffect, useRef, useState } from 'react';

const ImageCarousel = ({ imageArray, theme }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [images, setImages] = useState(imageArray);
    const [isInteracting, setIsInteracting] = useState(true);
    const [initialized, setInitialized] = useState(false);

    const element = useRef(null);

    // Create an intersection observer to observe the carousel element
    const observer = new IntersectionObserver((entries) => {
        // Check if the carousel element is intersecting with the viewport
        if (entries[0].isIntersecting) {
            // If it is, start the interval
            setCurrentIndex(0)
            setInitialized(true)
            setIsInteracting(false)
        }
        else {
            // If it is not, clear the interval
            setIsInteracting(true)
            setInitialized(false)
        }
    });

    useEffect(() => {
        if (!isInteracting || !initialized) return

        setTimeout(() => {
            setIsInteracting(false);
        }, 5000);

    }, [isInteracting])

    useEffect(() => {
        // Observe the carousel element
        observer.observe(element.current);

        return () => {
            // Disconnect the observer when the component is unmounted
            observer.disconnect();
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            // Check if we are at the last slide, if so, go back to the first slide
            if (isInteracting) return
            if (currentIndex === images.length - 1) {
                setCurrentIndex(0);
            } else {
                setCurrentIndex(currentIndex + 1);
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [currentIndex, isInteracting]);

    const Indicator = ({ index }) => (
        <span
            style={{
                margin: '0 0px',
                cursor: 'pointer',
                padding: '8px',

                color: theme.palette.text.primary,
                opacity: index === currentIndex ? 1 : 0.3,
            }}
            onClick={() => setCurrentIndex(index)}
        >
            <LensIcon style={{
                width: '10px',
                height: '18px',
            }} />


        </span>
    );

    return (
        <div style={{ maxWidth: "40vh" }} ref={element}>

            <div style={{ position: "relative", overflow: "hidden" }}>
                <div
                    style={{
                        display: 'flex',
                        transition: '.5s ease-in-out',
                        transform: `translateX(-${currentIndex * 100}%)`
                    }}
                    onMouseEnter={() => setIsInteracting(false)}
                    onMouseLeave={() => setIsInteracting(false)}
                >
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            style={{
                                width: '100%',
                                height: 'auto',
                                objectFit: 'contain', // this ensures the image fits within its frame
                                transition: '.5s ease-in-out',
                            }}
                            alt={`carousel-img-${index}`}
                        />
                    ))}
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative", justifyContent: "center" }}>
                {images.map((_, index) => (
                    <Indicator key={index} index={index} />
                ))}
            </div>

        </div>
    );
};

export default ImageCarousel;